export const windowOpenUtils = (url: string, name: string) => {
  setTimeout(() => {
    // window.name = name;
    window.open(url, name);
  });
};

export default ({ windowOpenUtils });
